import "./Answers.scss";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Dots from "react-activity/dist/Dots";
import Button from "../components/Button";
import { CSVLink } from "react-csv";

function Answers() {
  const { id } = useParams();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const csvData = [
    ["question1", "question2", "question3"],
    ["réponse1.1", "réponse1.2", "réponse1.3"],
  ];

  const deleteAnswer = async (answerId) => {
    const response = await axios.delete(
      `https://tell-me-more-backend-nyfc.onrender.com/answer/delete/${answerId}`
    );
    console.log(response.data);
    setData("");
  };

  const deleteAllAnswers = async (formId) => {
    const response = await axios.delete(
      `https://tell-me-more-backend-nyfc.onrender.com/answer/deleteAll/${formId}`
    );
    console.log(response.data);
    setData("");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://tell-me-more-backend-nyfc.onrender.com/answer/${id}`
        );

        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.response);
      }
    };
    fetchData();
  }, [id, data]);

  return isLoading ? (
    <Dots />
  ) : data[0] === undefined ? (
    <div className="createFormContainer noAnswers">
      Il n'y a pas encore de réponses pour ce formulaire
    </div>
  ) : (
    <div className="createFormContainer">
      <div className="createFormTop">
        <Link className="link" to={"/backoffice"}>
          Formulaires
        </Link>
        <div>
          <Button
            text={"Supprimer toutes les réponses"}
            color={"red"}
            func={() => {
              deleteAllAnswers(data[0].form._id);
            }}
            show={true}
          />
          <CSVLink className="CSVlink" data={csvData}>
            Exporter en CSV
          </CSVLink>
        </div>
      </div>
      <div className="createFormBottom">
        <h2>{data[0].form.title}</h2>
        {data.map((item, Qindex) => {
          return (
            <div key={Qindex} className="questionAnswerBlock">
              {item.answersArray.map((answer, index) => {
                return (
                  <div key={index}>
                    <div className="questionDiv">
                      <div
                        className={
                          item.form.questionsArray[index].category === 1
                            ? "iconDiv icon1"
                            : item.form.questionsArray[index].category === 2
                            ? "iconDiv icon2"
                            : item.form.questionsArray[index].category === 3
                            ? "iconDiv icon3"
                            : "iconDiv icon4"
                        }
                      >
                        {item.form.questionsArray[index].category} -{" "}
                      </div>
                      <div className="question">
                        {item.form.questionsArray[index].question}
                      </div>
                    </div>
                    <div className="answer">{answer.answer}</div>
                  </div>
                );
              })}
              <div className="bottomAnswer">
                <div className="pagination">
                  réponse {Qindex + 1} / {data.length}
                </div>
                <Button
                  text={"Supprimer la réponse"}
                  color={"red"}
                  func={() => {
                    deleteAnswer(item._id);
                  }}
                  show={true}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Answers;
